import React from 'react'

import useAppStore from '../../../useAppStore';

import  '../../wordRain/wordRain.js';
import WordRain from '../../wordRain/wordRain.js';
const About = ({ open, setOpen, title }) => {
    const { isViewOpen, closeView} = useAppStore(); // Access state and actions from the store

  return (
          <div className='text-base h-screen'>
            <WordRain className='h-screen'/>
          </div>
  );
}

export default About
